import { Checkbox as AntdCheckbox, CheckboxProps } from 'antd'

export const Checkbox = (props: CheckboxProps) => <AntdCheckbox {...props} />
